import React, { useEffect, useRef } from 'react';
import './CustomCursor.css';

function CustomCursor() {
  const cursorDot = useRef(null);
  const cursorOutline = useRef(null);

  const cursorX = useRef(0);
  const cursorY = useRef(0);
  const outlineX = useRef(0);
  const outlineY = useRef(0);
  const animationRef = useRef(null);

  useEffect(() => {
    const dot = cursorDot.current;
    const outline = cursorOutline.current;

    const handleMouseMove = (e) => {
      cursorX.current = e.clientX;
      cursorY.current = e.clientY;

      // Move dot instantly via DOM — no React re-render
      if (dot) {
        dot.style.left = `${e.clientX}px`;
        dot.style.top = `${e.clientY}px`;
      }

      // Check if hovering over interactive elements
      const target = e.target;
      const isInteractive =
        target.tagName === 'BUTTON' ||
        target.tagName === 'A' ||
        target.closest('button') ||
        target.closest('a') ||
        target.classList.contains('project-card') ||
        target.classList.contains('service-card') ||
        target.classList.contains('filter-btn') ||
        target.closest('.project-card') ||
        target.closest('.service-card');

      if (dot) dot.classList.toggle('pointer', isInteractive);
      if (outline) outline.classList.toggle('pointer', isInteractive);
    };

    const handleMouseDown = () => {
      if (dot) dot.classList.add('clicking');
      if (outline) outline.classList.add('clicking');
    };

    const handleMouseUp = () => {
      if (dot) dot.classList.remove('clicking');
      if (outline) outline.classList.remove('clicking');
    };

    const handleMouseEnter = () => {
      if (dot) dot.classList.remove('hidden');
      if (outline) outline.classList.remove('hidden');
    };

    const handleMouseLeave = () => {
      if (dot) dot.classList.add('hidden');
      if (outline) outline.classList.add('hidden');
    };

    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    document.addEventListener('mousedown', handleMouseDown);
    document.addEventListener('mouseup', handleMouseUp);
    document.addEventListener('mouseenter', handleMouseEnter);
    document.addEventListener('mouseleave', handleMouseLeave);

    // Smooth animation for cursor outline
    const animateOutline = () => {
      const speed = 0.35;
      outlineX.current += (cursorX.current - outlineX.current) * speed;
      outlineY.current += (cursorY.current - outlineY.current) * speed;

      if (outline) {
        outline.style.left = `${outlineX.current}px`;
        outline.style.top = `${outlineY.current}px`;
      }

      animationRef.current = requestAnimationFrame(animateOutline);
    };

    animationRef.current = requestAnimationFrame(animateOutline);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mousedown', handleMouseDown);
      document.removeEventListener('mouseup', handleMouseUp);
      document.removeEventListener('mouseenter', handleMouseEnter);
      document.removeEventListener('mouseleave', handleMouseLeave);
      cancelAnimationFrame(animationRef.current);
    };
  }, []);

  return (
    <>
      <div ref={cursorDot} className="cursor-dot" />
      <div ref={cursorOutline} className="cursor-outline" />
    </>
  );
}

export default CustomCursor;
